import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { Spinner } from '../../ui/spinner';
import { Switch } from '../../ui/switch';
import { connect } from 'react-redux';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import Breadcrumb from '../../Common/Breadcrumb';
import Select from 'src/components/ui/BrandSelect';
import { Reorder, useDragControls } from 'motion/react';
import { v4 as uuidv4 } from 'uuid';
import { X, Pencil, Trash2, Move, ArrowUpDown, Info, RotateCcw, Plus, Download, Loader2, Save, ArrowUp } from 'lucide-react';
import { Actions as ADMINACTIONS } from '../../../store/actions/adminActions';

const getWidth = (key) => {
  switch (key) {
    case 'name':
      return '22%';
    case 'order':
      return '5%';
    default:
      return '9%';
  }
};

const Modal = ({ modal, setModal, templates, filteredTemplates, setFilteredTemplates, metricOptions }) => {
  const [state, setState] = useState(
    modal?.item
      ? { ...modal?.item }
      : { title: false, subtitle: false, fixed: false, total: false, footnote: false, metric: null }
  );
  const [message, setMessage] = useState(false);
  const handleChange = (e) => {
    setMessage(false);
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const selectOptions = [
    { label: 'True', value: true },
    { label: 'False', value: false },
  ];

  if (modal?.action === 'delete') {
    return (
      <div className='modal' style={{ display: 'block', background: 'rgba(0,0,0,.5)' }}>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <button onClick={() => setModal(false)} className='modal-close'>
                <X size={16} strokeWidth={1.5} />
              </button>
              <h4 className='modal-title'>Delete Report Row</h4>
            </div>
            <div className='modal-body'>
              <p>Are you sure you want to delete this row?</p>
            </div>
            <div className='modal-footer' style={{ display: 'flex', justifyContent: 'center', gap: 10 }}>
              <Button
                onClick={() => {
                  setFilteredTemplates((prev) => prev.filter((item) => item.id !== modal?.item.id));
                  setModal(false);
                }}
                variant='destructive'
                id='modal-delete'>
                Delete
              </Button>
              <Button variant='secondary' onClick={() => setModal(false)} id='modal-cancel'>
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='modal' style={{ display: 'block', background: 'rgba(0,0,0,.5)' }}>
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-header'>
            <button onClick={() => setModal(false)} className='modal-close'>
              <X size={16} strokeWidth={1.5} />
            </button>
            <h4 className='modal-title'>{modal?.item ? 'Edit' : 'Add'} Report Row</h4>
          </div>
          <div className='modal-body'>
            <div className='form-group'>
              <label>Order</label>
              <Input
                type='number'
                name='order'
                id='order'
                placeholder='Order'
                value={state?.order ?? ''}
                onChange={(e) => {
                  handleChange(e);
                }}
              />
            </div>
            <div className='form-group'>
              <label>Report Type</label>
              <Select
                placeholder='Select Report Type'
                onChange={(selected) => {
                  setMessage(false);
                  setState({ ...state, reportType: selected.value });
                }}
                options={templates}
                value={templates?.find((opt) => opt.value == state?.reportType) || null}
              />
            </div>
            <div className='form-group'>
              <label>Name</label>
              <Input
                type='text'
                name='name'
                id='name'
                placeholder='Name'
                value={state?.name ?? ''}
                onChange={(e) => {
                  handleChange(e);
                }}
              />
            </div>
            <div className='form-group'>
              <label>Metric</label>
              <Select
                placeholder='Metric'
                isClearable={true}
                onChange={(selected) => {
                  setMessage(false);
                  setState({ ...state, metric: selected.value });
                }}
                options={metricOptions}
                value={metricOptions?.find((opt) => opt.value == state?.metric) || null}
              />
            </div>
            <div className='form-group'>
              <label>Title</label>
              <Select
                placeholder='Title'
                onChange={(selected) => {
                  setMessage(false);
                  setState({ ...state, title: selected.value });
                }}
                options={selectOptions}
                value={selectOptions?.find((opt) => opt.value == state?.title) || null}
              />
            </div>
            <div className='form-group'>
              <label>Subtitle</label>
              <Select
                placeholder='Subtitle'
                onChange={(selected) => {
                  setMessage(false);
                  setState({ ...state, subtitle: selected.value });
                }}
                options={selectOptions}
                value={selectOptions?.find((opt) => opt.value == state?.subtitle) || null}
              />
            </div>
            <div className='form-group'>
              <label>Fixed</label>
              <Select
                placeholder='Fixed'
                onChange={(selected) => {
                  setMessage(false);
                  setState({ ...state, fixed: selected.value });
                }}
                options={selectOptions}
                value={selectOptions?.find((opt) => opt.value == state?.fixed) || null}
              />
            </div>
            <div className='form-group'>
              <label>Total</label>
              <Select
                placeholder='Total'
                onChange={(selected) => {
                  setMessage(false);
                  setState({ ...state, total: selected.value });
                }}
                options={selectOptions}
                value={selectOptions?.find((opt) => opt.value == state?.total) || null}
              />
            </div>
            <div className='form-group'>
              <label>Footnote</label>
              <Select
                placeholder='Footnote'
                onChange={(selected) => {
                  setMessage(false);
                  setState({ ...state, footnote: selected.value });
                }}
                options={selectOptions}
                value={selectOptions?.find((opt) => opt.value == state?.footnote) || null}
              />
            </div>
            {message && <span style={{ color: 'red' }}>Please fill in all the fields.</span>}
          </div>
          <div className='modal-footer' style={{ display: 'flex', justifyContent: 'center', gap: 10 }}>
            <Button
              onClick={() => {
                if (state?.order === undefined || state?.name === undefined || state?.reportType === undefined) {
                  setMessage(true);
                  return;
                }
                if (!modal?.item) {
                  //add this item in the index specified in the state.order field to the filteredTemplates array
                  const item = { ...state, id: uuidv4() };
                  const newFilteredTemplates = [...filteredTemplates];
                  const index = parseInt(state?.order) - 1;
                  if (index !== -1) {
                    newFilteredTemplates.splice(index, 0, item);
                  } else {
                    newFilteredTemplates.push(item);
                  }
                  setFilteredTemplates(newFilteredTemplates);
                } else {
                  //edit this item in the filteredTemplates array
                  const newFilteredTemplates = [...filteredTemplates];
                  const currentIndex = newFilteredTemplates.findIndex((item) => item.id === modal?.item.id);

                  if (currentIndex !== -1) {
                    // Remove the item from its current position
                    const [movedItem] = newFilteredTemplates.splice(currentIndex, 1);

                    // Insert the item at the new index
                    const newIndex = Math.max(0, Math.min(parseInt(state?.order) - 1, newFilteredTemplates.length));
                    newFilteredTemplates.splice(newIndex, 0, { ...state });

                    // Update the state with the new array
                    setFilteredTemplates(newFilteredTemplates);
                  }
                }

                setModal(false);
              }}
              id='modal-save'>
              {modal?.item ? 'Edit' : 'Add'}
            </Button>
            <Button variant='secondary' onClick={() => setModal(false)} id='modal-cancel'>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const TableItem = ({ template, index, setModal, filteredTemplates, setFilteredTemplates, editMode, metrics }) => {
  const [quickMove, setQuickMove] = useState('');
  const controls = useDragControls();
  const handleDragStart = () => {
    document.body.style.userSelect = 'none'; // Disable text selection
  };

  const handleDragEnd = () => {
    document.body.style.userSelect = ''; // Re-enable text selection
  };
  return (
    <Reorder.Item
      as='div'
      key={template.id}
      value={template}
      id={template.id}
      dragListener={false}
      dragControls={controls}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      style={{
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        padding: '8px 5px',
        border: '1px solid #ccc',
        borderRadius: '5px',
        backgroundColor: '#f9f9f9',
        width: '100%',
        flexDirection: 'row',
      }}>
      {['order', 'name', ...Object.keys(template).filter((key) => !['id', 'order', 'name', 'reportType'].includes(key))].map(
        (key) => (
          <span key={key} style={{ width: getWidth(key), textAlign: 'left', padding: '10px 12px' }}>
            {typeof template[key] === 'boolean'
              ? _.capitalize(template[key].toString())
              : key === 'order'
              ? index
              : key === 'metric'
              ? metrics?.find((metric) => metric.id === template[key])?.name || template[key] || 'Empty'
              : template[key] == null
              ? 'Empty'
              : template[key]}
          </span>
        )
      )}

      <div style={{ width: '8%', padding: 10 }}>
        <button
          style={{ border: 'none', background: 'none', cursor: 'pointer' }}
          onClick={() => {
            setModal({ status: true, item: { ...template, order: index } });
          }}>
          <Pencil size={20} strokeWidth={1.5} />
        </button>
        <button
          style={{ border: 'none', background: 'none', cursor: 'pointer' }}
          onClick={() => {
            setModal({ status: true, item: { ...template, order: index }, action: 'delete' });
          }}>
          <Trash2 size={20} strokeWidth={1.5} />
        </button>
      </div>
      <div
        style={{
          display: editMode ? 'flex' : 'none',
          justifyContent: 'center',
          flexDirection: 'row',
          alignItems: 'center',
          flexGrow: 1,
          gap: 10,
        }}>
        <div
          onPointerDown={(event) => {
            controls.start(event);
          }}
          style={{
            cursor: 'grab',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 30,
            height: 30,
          }}>
          <Move size={18} strokeWidth={1.5} style={{ cursor: 'grab' }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2, justifyContent: 'center', alignItems: 'center' }}>
          <label style={{ fontSize: 12 }}>Quick Move:</label>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <input
              type='number'
              style={{
                width: 40,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderWidth: 1,
                borderTopLeftRadius: 3,
                borderBottomLeftRadius: 3,
              }}
              value={quickMove ?? ''}
              onChange={(e) => setQuickMove(e.target.value)}></input>
            <Button
              variant='ghost'
              size='sm'
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
              }}
              onClick={() => {
                if (quickMove !== null) {
                  const newFilteredTemplates = [...filteredTemplates];
                  const currentIndex = newFilteredTemplates.findIndex((item) => item.id === template.id);

                  if (currentIndex !== -1) {
                    // Remove the item from its current position
                    const [movedItem] = newFilteredTemplates.splice(currentIndex, 1);

                    // Insert the item at the new index
                    const newIndex = Math.max(0, Math.min(parseInt(quickMove) - 1, newFilteredTemplates.length));
                    newFilteredTemplates.splice(newIndex, 0, movedItem);

                    // Update the state with the new array
                    setFilteredTemplates(newFilteredTemplates);
                    setQuickMove(null); // Reset the quick move input
                  }
                }
              }}>
              <ArrowUpDown size={16} strokeWidth={1.5} />
            </Button>
          </div>
        </div>
      </div>
    </Reorder.Item>
  );
};

const ReportTemplates = ({
  branding,
  templates,
  reportTemplates,
  getAllItemsFromDB,
  sidebar,
  saveReportTemplate,
  showLoader,
  metricOptions,
  metrics,
}) => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [filteredTemplates, setFilteredTemplates] = useState([]);
  const originalTemplates = reportTemplates.filter((template) => template.reportType === selectedTemplate);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [modal, setModal] = useState(false);
  const [saveMessage, setSaveMessage] = useState(false);

  const { body } = branding.fonts?.[0].font;

  useEffect(() => {
    if (!_.isEqual(_.sortBy(originalTemplates, 'order'), _.sortBy(filteredTemplates, 'order'))) {
      setSaveMessage(true);
    } else {
      setSaveMessage(false);
    }
  }, [filteredTemplates, originalTemplates]);

  useEffect(() => {
    getAllItemsFromDB('reportTemplates');

    // Add scroll event listener to toggle the button visibility
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [getAllItemsFromDB]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!reportTemplates?.length > 0 && !reportTemplates) {
    return <Spinner />;
  }

  return (
    <>
      <Breadcrumb items={[{ label: 'Report Templates', link: '/admin/templates' }]} />
      <div className='row' style={{ fontFamily: body }}>
        <div className='col-lg-12'>
          <section className='panel'>
            <header
              className='panel-heading'
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              Report Templates
              <div style={{ width: 250 }}>
                <Select
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 3,
                    }),
                  }}
                  placeholder='Select Template'
                  onChange={(selected) => {
                    setSelectedTemplate(selected.value);
                    setFilteredTemplates(
                      _.sortBy(
                        reportTemplates.filter((template) => template.reportType === selected.value),
                        'order'
                      )
                    );
                  }}
                  options={templates}
                />
              </div>
            </header>
            <div className='panel-body'>
              {!selectedTemplate && (
                <p style={{ fontSize: 16, fontWeight: 'bold', textAlign: 'center' }}>
                  Select a Template to view and edit it!
                </p>
              )}
              {selectedTemplate && (
                <>
                  <div style={{ position: 'sticky', top: 80, backgroundColor: 'white', zIndex: 2, paddingTop: 10 }}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'end',
                        marginBottom: 16,
                        alignItems: 'center',
                        gap: 10,
                      }}>
                      <span>
                        {saveMessage && (
                          <>
                            <span style={{ color: 'red', marginRight: 10 }}>
                              <Info size={16} strokeWidth={1.5} style={{ display: 'inline' }} /> You have Unsaved changes
                            </span>
                            <Button
                              onClick={() => {
                                setFilteredTemplates(
                                  _.sortBy(
                                    reportTemplates.filter((template) => template.reportType === selectedTemplate),
                                    'order'
                                  )
                                );
                                setSaveMessage(false);
                              }}>
                              <RotateCcw size={16} strokeWidth={1.5} style={{ marginRight: '5px' }} />
                              Undo Changes
                            </Button>
                          </>
                        )}
                      </span>
                      <Button
                        onClick={() => {
                          setModal({ status: true });
                        }}>
                        <Plus size={16} strokeWidth={1.5} style={{ marginRight: '5px' }} />
                        Add New Row
                      </Button>
                      <Button
                        onClick={() => {
                          // Add your download functionality here
                        }}>
                        <Download size={16} strokeWidth={1.5} style={{ marginRight: '5px' }} />
                        Download Excel
                      </Button>
                      <Button
                        onClick={() => {
                          //Map through the filteredTemplates array and save each template to the database
                          const arrayToSave = filteredTemplates.map((template, index) => ({
                            ...template,
                            order: index + 1,
                          }));
                          saveReportTemplate(arrayToSave);
                          setSaveMessage(false);
                        }}>
                        {showLoader ? (
                          <Loader2 size={16} strokeWidth={1.5} className="animate-spin" style={{ marginRight: '5px' }} />
                        ) : (
                          <Save size={16} strokeWidth={1.5} style={{ marginRight: '5px' }} />
                        )}
                        {showLoader ? 'Saving...' : 'Save'}
                      </Button>
                    </div>
                    <table id='users-table' className='app-table'>
                      <thead>
                        <tr>
                          {filteredTemplates.length > 0 &&
                            [
                              'order',
                              'name',
                              ...Object.keys(filteredTemplates[0] || {}).filter(
                                (key) => !['id', 'order', 'name', 'reportType'].includes(key)
                              ),
                              'actions',
                            ].map((key) => (
                              <th key={key} style={{ width: getWidth(key) }}>
                                {_.capitalize(key)}
                              </th>
                            ))}
                          <th style={{ width: '10%' }}>
                            <div className='flex items-center flex-row gap-2'>
                              Edit Mode
                              <Switch
                                checked={editMode}
                                onCheckedChange={() => setEditMode(!editMode)}
                              />
                            </div>
                          </th>
                        </tr>
                      </thead>
                    </table>
                  </div>

                  <Reorder.Group
                    as='div'
                    axis='y'
                    onReorder={setFilteredTemplates}
                    values={filteredTemplates}
                    style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {filteredTemplates.map((template, index) => (
                      <TableItem
                        key={template.id}
                        template={template}
                        index={index + 1}
                        setModal={setModal}
                        filteredTemplates={filteredTemplates}
                        setFilteredTemplates={setFilteredTemplates}
                        editMode={editMode}
                        metrics={metrics}
                      />
                    ))}
                  </Reorder.Group>
                </>
              )}
            </div>
            {modal?.status && (
              <Modal
                setModal={setModal}
                modal={modal}
                templates={templates}
                filteredTemplates={filteredTemplates}
                setFilteredTemplates={setFilteredTemplates}
                metricOptions={metricOptions}
              />
            )}
          </section>
        </div>
      </div>
      {showScrollButton && (
        <button
          onClick={scrollToTop}
          title='Go to top'
          style={{
            position: 'fixed',
            left: sidebar ? 'calc(50% + 120px)' : '50%',
            transform: 'translateX(-50%)',
            bottom: 40,
            backgroundColor: '#fff',
            color: 'black',
            border: '1px solid #ccc',
            borderRadius: '50%',
            width: '45px',
            height: '45px',
            cursor: 'pointer',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.2)',
            zIndex: 1000,
          }}>
          <ArrowUp size={18} strokeWidth={1.5} />
        </button>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const reportTemplates = state?.admin?.adminPortal?.reportTemplates || [];
  const templates = _.uniqBy(reportTemplates, 'reportType').map((template) => ({
    label: template.reportType,
    value: template.reportType,
  }));
  const metrics = state?.metric?.list || [];
  let metricOptions = metrics.map((metric) => ({
    label: metric.name,
    value: metric.id,
  }));
  metricOptions = _.sortBy(metricOptions, 'label');
  metricOptions.unshift({ label: 'tCO2e / £m', value: 'tCO2e per million' });
  return {
    branding: state.branding,
    templates,
    reportTemplates,
    sidebar: state?.sidebar?.show,
    showLoader: state?.showLoader,
    metricOptions,
    metrics,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getAllItemsFromDB: (table) => dispatch(ADMINACTIONS.getAllItemsFromDB(table)),
  saveReportTemplate: (template) => dispatch(ADMINACTIONS.saveReportTemplate(template)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportTemplates);
